import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from './Constants';
import Display from './Display';  
import StudentTab from './StudentTab';
import TutorTab from './TutorTab';

const EnrollmentsListTutor = (props) => {
  const  id  = props.id;
  const studentId = props.studentId;
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [flagged, setFlagged] = useState(true);
  const [enrollmentId, setEnrollmentId] = useState(null);
  

  // Fetch enrollments from API
  useEffect(() => {
    const fetchEnrollments = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/enrollments`);
        const filteredData = res.data.filter(enrollment => enrollment.tutor_id === id);
        setEnrollments(filteredData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching enrollments', err);
        setError('Failed to load enrollments');
        setLoading(false);
      }
    };

    fetchEnrollments();
  }, []);

  // Function to get initials from course name
  const getInitials = (name) => {
    if (!name) return 'NA';
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const handleClick = (enrollment_id) => {
    setEnrollmentId(enrollment_id);
    setFlagged(false);

  };

  // Function to get background color based on course name
  const getAvatarColor = (name) => {
    if (!name) return 'bg-primary';
    
    const colors = [
      'bg-primary', 'bg-secondary', 'bg-accent', 
      'bg-info', 'bg-success', 'bg-warning', 'bg-error'
    ];
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <span className="loading loading-spinner loading-lg"></span>
        <span className="ml-2">Loading enrollments...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error shadow-lg max-w-2xl mx-auto my-8">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{error}</span>
        </div>
      </div>
    );
  }

  return (
    <>
    
       <div className="container mx-auto p-4">
     
      {flagged?<h1 className="text-2xl font-bold text-center mb-8 text-white bg-primary">Enrollments</h1>:null}

      {enrollments.length === 0? (
        
        <div className="alert alert-warning shadow-lg max-w-2xl mx-auto">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span>No enrollments found.</span>
          </div>
        </div>
      ) : (
        flagged ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {enrollments.map(enrollment => (
              <div onClick={() => handleClick(enrollment.id)} key={enrollment.id} className="card bg-base-100 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                <div className="card-body cursor-pointer">
                  <div className="flex items-center mb-4">
                    <div className={`avatar placeholder ${getAvatarColor(enrollment.course_name)} text-white`}>
                      <div className="rounded-full w-12 h-12 flex items-center justify-center">
                        <span className="text-xl font-bold">{getInitials(enrollment.course_name)}</span>
                      </div>
                    </div>
                    <div className="ml-4">
                      <h2 className="card-title">{enrollment.course_name}</h2>
                      <p className="text-sm text-gray-500">ID: {enrollment.id}</p>
                    </div>
                  </div>
                  
                  <div className="divider my-2"></div>
                  
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="font-semibold">Student:</span>
                      <span>{enrollment.student ? enrollment.student.name : `ID: ${enrollment.student_id}`}</span>
                    </div>
                    
                    <div className="flex justify-between">
                      <span className="font-semibold">Tutor:</span>
                      <span>{enrollment.tutor ? enrollment.tutor.name : `ID: ${enrollment.tutor_id}`}</span>
                    </div>
                    
                    <div className="flex justify-between">
                      <span className="font-semibold">Grade:</span>
                      <span>{enrollment.grade || 'N/A'}</span>
                    </div>
                    
                    <div className="flex justify-between">
                      <span className="font-semibold">Subject:</span>
                      <span>{enrollment.subject || 'N/A'}</span>
                    </div>
                    
                    <div className="flex justify-between">
                      <span className="font-semibold">Syllabus:</span>
                      <span>{enrollment.syllabus || 'N/A'}</span>
                    </div>
                    
                    <div className="flex justify-between">
                      <span className="font-semibold">Type:</span>
                      <span className="badge badge-outline">{enrollment.type}</span>
                    </div>
                  </div>
                  
                  <div className="divider my-2"></div>
                  
                  <div className="flex justify-between items-center mt-2">
                    <span className="font-semibold">Status:</span>
                    <span className={`badge ${enrollment.status === 'active' ? 'badge-success' : enrollment.status === 'completed' ? 'badge-info' : 'badge-warning'}`}>
                      {enrollment.status}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <TutorTab id={enrollmentId} tutorId={id} studentId={studentId} />
        )
      )}
    </div>
    </>
  );
};

export default EnrollmentsListTutor;